import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { ChartWithBackgroundOptions } from './chart-with-background';

const TIME_TO_FIRST_VISIT_MAX_DAYS = 10;

export const timeToFirstVisitChartData = (
  timeToFirstVisitByDay: CampaignAnalyticsReport['timeToFirstVisitByDay']
): ChartWithBackgroundOptions['chartData'] =>
  timeToFirstVisitByDay.visible
    ? timeToFirstVisitByDay.data
        .toSorted((a, b) => b.daysAfterAdExposure - a.daysAfterAdExposure)
        .slice(-TIME_TO_FIRST_VISIT_MAX_DAYS)
        .map(data => ({
          name: `Day ${data.daysAfterAdExposure}`,
          value: data.percentageOfUsers * 100,
        }))
    : [];
